export function escapeHtml(s: unknown): string {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export const escapeAttr = escapeHtml;

const KIND_EMOJI: Record<string, string> = {
  sprite: "🖼️",
  object: "🧱",
  sound: "🔊",
  shader: "✨",
  script: "📜",
  room: "🗺️",
  font: "🔤",
  tileset: "🧩",
};

export function kindEmoji(kind: string): string {
  return KIND_EMOJI[kind] ?? "📄";
}

/** Typed getElementById that throws if the element is missing. */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`missing element #${id}`);
  return el as T;
}
